export default __webpack_public_path__ + "static/media/CD-Pattern.890bac57.jpg";